module.exports = __webpack_public_path__ + "static/media/img_slideshow4vr.b28e23d8.jpg";